.examplesNavList {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
}

.examplesNavList li {
    flex: 1 1 390px;
    max-width: 630px;
    min-width: 390px;
}

.exampleButton {
    width: 100%;
    height: 180px;
    padding: 20px;
    box-sizing: border-box;

    /* Remove line-clamp, JS handles truncation */
    overflow: hidden;

    font-size: 22px;
    line-height: 1.3;
    font-family: monospace;
    font-weight: 500;
    color: #333;
    text-align: left;
    word-break: break-word;
    white-space: pre-wrap;

    border-radius: 16px;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid rgba(0, 0, 0, 0.06);
    backdrop-filter: blur(4px);
    cursor: pointer;
    transition:
        transform 0.25s ease,
        box-shadow 0.25s ease,
        border-color 0.25s ease;
}

.exampleButton:hover,
.exampleButton:focus {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
    border-color: rgba(122, 79, 246, 0.3);
    outline: none;
}

.exampleButton:active {
    transform: translateY(0);
    box-shadow: none;
}

@media (max-width: 900px) {
    .examplesNavList li {
        flex: 1 1 330px;
        min-width: 330px;
    }

    .exampleButton {
        height: 150px;
    }
}

@media (max-width: 600px) {
    .examplesNavList {
        gap: 12px;
    }

    .examplesNavList li {
        flex: 1 1 100%;
        min-width: 100%;
    }

    .exampleButton {
        height: 128px;
        padding: 16px;
    }
}
